import { useState } from "react";
import Answer from "./Answer";
import Player from "./Player";
import Score from "./Score";
import { GameContext } from "../context/globalContext";


export default function Endless({gamemode}) {
    const [currentSong, setCurrentSong] = useState(null)
    const [score, setScore] = useState(null)
    const [answerContext, setAnswerContext] = useState(null)
    const [songIndex, setSongIndex] = useState(0)
    const [songsContext, setSongsContext] = useState(0)
    
    const player = {
        name: 'Mutuca',
        id: '1'
    }
    
    return(
        <div className="game">
            <GameContext.Provider value={{currentSong, setCurrentSong, score, setScore, answerContext, setAnswerContext, setSongIndex, songIndex, songsContext, setSongsContext}}>
                <Score player={player} gamemode={gamemode}/>
                {<Player gamemode={gamemode}/>}
                <Answer/>
            </GameContext.Provider>
        </div>
    )
}